import React, { FunctionComponent, useState, useEffect } from "react";
import { AM, PM } from "../constants";
import { TimeConverter, ArrowIcon, TimeWrapper } from "./styles";

interface TimeIconProps {
    AMorPM?: string;
    toggleAMPM: (a: string) => void;
    value?: string;
}

export const TimeIcon: FunctionComponent<TimeIconProps> = ({ AMorPM, toggleAMPM, value }) => {
    const [isAMActive, toggleAMActive] = useState(AMorPM === AM);

    useEffect(() => {
        toggleAMActive(AMorPM === AM);
    }, [AMorPM]);

    return (
        <>
            <ArrowIcon />
            <TimeWrapper>
                <TimeConverter
                    active={value && isAMActive}
                    onClick={(): void => {
                        toggleAMPM(AM);
                        toggleAMActive(true);
                    }}
                >
                    <b>AM</b>
                </TimeConverter>
                <TimeConverter
                    active={value && !isAMActive}
                    onClick={(): void => {
                        toggleAMPM(PM);
                        toggleAMActive(false);
                    }}
                >
                    <b>PM</b>
                </TimeConverter>
            </TimeWrapper>
        </>
    );
};
